import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-white text-center w-8/12" }, "Reset your password", -1)
const _hoisted_2 = { class: "w-full align-middle mt-[50px] flex flex-col gap-6 bg-white shadow-base h-fit rounded-3xl px-5 py-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

import { ref } from "vue"
  import jwt from "@/utils/jwt"
  import { generateSchema } from "@/utils/validate"
  import { useAuthenticationStore } from "@/store/authentication"

  import FormContainer from "@/components/template/formTemplate.vue"
  import WbTemplate from "@/components/account-creation/template.vue"
  import WbInput from "@/components/template/InputTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

  const email = ref("")
  const validationSchema = generateSchema([
    {
      name: "email",
      rule: "email",
    },
  ])

  const authenticationStore = useAuthenticationStore()

  const sendResetRequest = () => {
    authenticationStore.requestResetPassword(jwt.generateNBF(), email.value)
  }

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(WbTemplate, null, {
    default: _withCtx(() => [
      _createVNode(FormContainer, {
        "validation-schema": _unref(validationSchema),
        class: "flex flex-col w-[25rem] items-center justify-center text-light-black",
        onValid: sendResetRequest
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(WbInput, {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              name: "email",
              placeholder: "Email *"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ion_button, {
              expand: "block",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Continue")
              ]),
              _: 1
            }),
            _hoisted_3
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _: 1
  }))
}
}

})